import axios from 'axios';
import getSBABaseUrl from 'lib/getSBABaseUrl';
import { getJwtToken } from '../../lib/auth/helpers';
import { VisitedActionTypes, VisitedActionCreators } from './types';

export const visitedRequest = (): VisitedActionCreators => {
  return { type: VisitedActionTypes.REQUEST };
};

export const visitedSuccess = (apiResults): VisitedActionCreators => {
  const data = apiResults.map((res) => ({
    tilstandsRapportId: res.tilstandsrapport_id,
    addresse: res.tilstandsrapport?.matrikkelId?.adresse,
    postnr: res.tilstandsrapport?.matrikkelId?.postnr,
    poststed: res.tilstandsrapport?.matrikkelId?.poststed,
    bilde: res.tilstandsrapport?.eiendom?.bilder ? res.tilstandsrapport?.eiendom?.bilder[0].url : null,
  }));

  return { type: VisitedActionTypes.SUCCESS, data };
};

export const visitedFailure = (error): VisitedActionCreators => {
  return { type: VisitedActionTypes.FAILURE, error };
};

export const addVisitedSuccess = (): VisitedActionCreators => {
  return { type: VisitedActionTypes.ADD };
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const doFetchVisited = () => {
  return async (dispatch): Promise<void> => {
    try {
      dispatch(visitedRequest());
      const token = await getJwtToken();
      const { data } = await axios.get(`${getSBABaseUrl()}/api/analyser/visited`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      dispatch(visitedSuccess(data));
    } catch (err) {
      dispatch(visitedFailure(err));
    }
  };
};

export const doAddVisited = (id: string) => {
  return async (dispatch): Promise<void> => {
    try {
      dispatch(visitedRequest());
      const token = await getJwtToken();
      await axios.post(
        `${getSBABaseUrl()}/api/analyser/visited/${id}`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      dispatch(addVisitedSuccess());
    } catch (err) {
      dispatch(visitedFailure(err));
    }
  };
};
